import { ERROR, SUCCESS, PROCESSING } from 'constants/forgot-password'

const INITIAL_STATE = {
  loading: false,
  message: '',
  messageType: '',
}

const forgotPasswordReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case PROCESSING:
      return {
        ...state,
        loading: true,
      }
    case SUCCESS:
      return {
        ...state,
        messageType: 'success',
        message: action.message,
        loading: false,
      }
    case ERROR:
      return {
        ...state,
        message: action.payload.email[0],
        messageType: 'alert',
        loading: false,
      }
    default:
      return state
  }
}

export default forgotPasswordReducer
